import * as React from 'react';
import type { CollapseProps } from '~/Partials/Collapse/Collapse';
import { Collapse } from '~/Partials/Collapse/Collapse';

export const LazyCollapse: React.FC<CollapseProps> = props => {
    const { isOpen, children, ...restProps } = props;

    const [isBeforeCollapsing, setIsBeforeCollapsing] = React.useState(isOpen);

    const handleOnRest = () => setIsBeforeCollapsing(isOpen);

    const shouldContentBeRendered = isOpen || isBeforeCollapsing;

    // Effect that trigger only when `isOpen` changes.
    // It compares it with the internal state to determine if the transition is about to start.
    React.useEffect(() => {
        if (isBeforeCollapsing !== isOpen) {
            setIsBeforeCollapsing(true);
        }
    }, [isOpen]);

    return (
        <Collapse {...restProps} isOpen={isOpen} onRest={handleOnRest}>
            {shouldContentBeRendered && children}
        </Collapse>
    );
};
